import autobind from 'core-decorators/lib/autobind';
import debounce from 'core-decorators/lib/debounce';

import WixSDK from 'shared/utils/wix-sdk';
import { REFRESH_EVENT, storeForReload } from 'widget/utils/reload';

const RELOAD_STORAGE_READY = 'reloadStorageReady';
const currentInstanceId = WixSDK.Utils.getInstanceId();


// TODO: enhance this to look like real storage with get/set/remove methods

/*
 * Since after UOU login or logout, whole site rebuilds, and there is no nice solution in WixSDK for this case.
 * This is workaround, that use persistent events in Wix.PubSub. Anytime we let user login or logout, we also
 * stores data, that we want to path into "next state" of widget after it's reloaded. But since we use
 * persistent events, they are stored in same sequence as we publish them until site is closed or manually refreshed.
 * But we need only last one, that's why we use @debounce for method `processRetrievedData`
 */
export default class ReloadStorage extends React.Component {

  static propTypes = {
    onReload: React.PropTypes.func,

    children: React.PropTypes.element,
  };

  static defaultProps = {
    onReload: _.noop,
  };

  state = {
    isProcessing: true,
  };

  componentDidMount() {
    storeForReload(RELOAD_STORAGE_READY);
    WixSDK.PubSub.subscribe(
      REFRESH_EVENT,
      this.saveEventData,
      true,
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  lastEventData = {};

  unsubscribe() {
    WixSDK.PubSub.unsubscribe(REFRESH_EVENT, this.saveEventData);
    storeForReload(null);
  }

  @autobind
  saveEventData({ data }) {
    if (!data || data.stored !== RELOAD_STORAGE_READY) {
      this.lastEventData = data || {};
    }
    this.retrieveDataAfterReload();
  }

  @debounce
  retrieveDataAfterReload() {
    const { onReload } = this.props;

    const { stored, instanceId } = this.lastEventData;

    if (instanceId === currentInstanceId && stored) {
      onReload(stored);
    }

    this.setState({ isProcessing: false });
    this.lastEventData = {};
  }

  render() {
    const { children } = this.props;

    if (!children || this.state.isProcessing) {
      return null;
    }

    return children;
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/reload-storage/reload-storage.js